module.exports = __webpack_public_path__ + "assets/8b4dd2b5548d88b2f243a5ad371cbaaf.mp3";